import { Badge } from "@l30/ui";

import type { CurationBand, ExtractionMatchKind } from "@l30/shared";

const BAND_VARIANT: Record<CurationBand, "success" | "warning" | "danger"> = {
  auto: "success",
  queue: "warning",
  flag: "danger",
};

/**
 * "merges into existing" marker on a dedup-matched extraction item. An
 * embedding match (ADR-0092) also shows its similarity so the reviewer can
 * judge the merge; the similarity rides in `payload.matchSimilarity`.
 */
export function MergeBadge({
  matchKind,
  payload,
}: {
  matchKind: ExtractionMatchKind;
  payload: Record<string, unknown>;
}) {
  if (matchKind === "none") return null;
  const label =
    matchKind === "embedding"
      ? `merges into existing (${Math.round(Number(payload["matchSimilarity"] ?? 0) * 100)}% similar)`
      : "merges into existing";
  return <Badge variant="warning">{label}</Badge>;
}

export function ConfidenceBadge({
  band,
  confidence,
}: {
  band: CurationBand | null;
  confidence: number | null;
}) {
  if (!band && confidence === null) return null;
  const pct = confidence === null ? null : `${Math.round(confidence * 100)}%`;
  const label = band ? `${band}${pct ? ` · ${pct}` : ""}` : pct;
  return <Badge variant={band ? BAND_VARIANT[band] : "default"}>{label}</Badge>;
}
